// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import PlusOutlined from '../_raw/ui/PlusOutlined.svg';
import withIconProps from '../withIconProps';

export default withIconProps(PlusOutlined);
